import React from 'react';
import { string, func, bool, oneOfType, element } from 'prop-types';
import { Box, FormControlLabel, Checkbox as MuiCheckbox, Tooltip, useTheme } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

const Checkbox = ({
  id,
  inputName,
  label,
  checked,
  onChange,
  onClick,
  disabled,
  tooltip,
}) => {
  const theme = useTheme();

  return (
    <React.Fragment>
      <FormControlLabel
        control={
          <MuiCheckbox
            id={id}
            name={inputName}
            checked={checked}
            onChange={onChange}
            icon={<div className="checkbox-icon" />}
            checkedIcon={<div className="checkbox-icon checkbox-icon_checked" />}
            onClick={onClick}
          />
        }
        label={label}
        disabled={disabled}
      />
      {tooltip && (
        <Box marginLeft="-4px" marginTop="2px">
          <Tooltip title={tooltip} placement="top" arrow>
            <InfoOutlined
              htmlColor={theme.palette.grey[300]}
              fontSize="small"
              sx={{
                cursor: 'pointer',
              }}
            />
          </Tooltip>
        </Box>
      )}
    </React.Fragment>
  );
};

export default Checkbox;

Checkbox.propTypes = {
  id: string,
  inputName: string,
  label: oneOfType([string, element]),
  checked: bool.isRequired,
  onChange: func.isRequired,
  disabled: bool,
  tooltip: string,
  onClick: func,
};

Checkbox.defaultProps = {
  id: '',
  inputName: '',
  label: '',
  disabled: false,
  tooltip: '',
  onClick: null,
};
